const formatRun = (run?: string | null): string => {
    if (!run || !run.includes('-')) {
        return ''
    }

    const splitRun = run.split('-')

    if (splitRun.length !== 2) {
        return ''
    }

    const [maybeLane, maybeLot] = splitRun

    const lane = maybeLane.trim()
    const lot = maybeLot.trim().padStart(4, '0')

    return `${lane}-${lot}`
}

export default formatRun
